export class EconomySystem {
  money: number;

  constructor(startingMoney = 120) {
    this.money = startingMoney;
  }

  canAfford(cost: number): boolean {
    return this.money >= cost;
  }

  spend(cost: number): boolean {
    if (!this.canAfford(cost)) return false;
    this.money -= cost;
    return true;
  }

  earn(amount: number): void {
    this.money += amount;
  }

  reset(): void {
    this.money = 120;
  }
}
